import { FC } from 'react';
import { Case, Switch } from '@edikk-edikk/if';
import { SocialLinkAlias } from './objects';
import { AppSvgSpriteMonoIcon } from '#src/svg';

type PropsType = {
  alias: string;
};

const AdvertSocialLinkIcon: FC<PropsType> = ({
  alias,
}) => (
  <Switch>
    <Case condition={alias === SocialLinkAlias.whatsApp}>
      <AppSvgSpriteMonoIcon name="messenger-whatsapp" />
    </Case>
    <Case condition={alias === SocialLinkAlias.instagram}>
      <AppSvgSpriteMonoIcon name="messenger-instagram-stroke" />
    </Case>
    <Case condition={alias === SocialLinkAlias.telegram}>
      <AppSvgSpriteMonoIcon name="messenger-telegram-stroke" />
    </Case>
    <Case condition={alias === SocialLinkAlias.twitch}>
      <AppSvgSpriteMonoIcon name="messenger-twitch-stroke" />
    </Case>
    <Case condition={alias === SocialLinkAlias.fansly}>
      <AppSvgSpriteMonoIcon name="messenger-fansly-stroke" />
    </Case>
    <Case condition={alias === SocialLinkAlias.onlyFans}>
      <AppSvgSpriteMonoIcon name="messenger-only-fans-stroke" />
    </Case>
    <Case condition={alias === SocialLinkAlias.xTwitter}>
      <AppSvgSpriteMonoIcon name="messenger-x-twitter-stroke" />
    </Case>
    <Case condition={alias === SocialLinkAlias.signal}>
      <AppSvgSpriteMonoIcon name="messenger-signal-stroke" />
    </Case>
  </Switch>
);

export { AdvertSocialLinkIcon };
